import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/** A QR code rendered locally (nothing is sent to a third-party QR service). */
export function QrImage({ value, size = 180, label }: { value: string; size?: number; label: string }) {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    void QRCode.toDataURL(value, { width: size * 2, margin: 1, errorCorrectionLevel: 'M', color: { dark: '#0a0a0a', light: '#ffffff' } }).then(u => { if (live) setSrc(u); });
    return () => { live = false; };
  }, [value, size]);
  return src ? <img src={src} alt={label} width={size} height={size} className="rounded-md border border-slate-200 bg-white p-1" /> : <div style={{ width: size, height: size }} className="animate-pulse rounded-md bg-slate-100" />;
}
